module.exports = __webpack_public_path__ + "img/userdefault.3c1fb03d.svg";